

<div class="offcanvas offcanvas-end notifi-canvas" data-bs-backdrop="true" tabindex="-1" id="notification_offcanvas_modal" aria-labelledby="offcanvasRightLabel">

  <div class="offcanvas-header">
    <h5 class="offcanvas-title text-capitalize" id="offcanvasRightLabel">{{ 'notification_modal_title' | translate: 'header' }}</h5>
    <button #closeButoon type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body notifi-box">

    <div
    class="notification-dropdown"
    *ngIf="notificationsData?.length"
    >
      <div
        class="product-detail w-100"
        *ngFor="let notification of notificationsData"
      >

        <div class="border-bottom d-flex notifi-header-cell p-3" (click)="switchtoDetailsProduct(notification)"  >

          <div class="img-box">
            <img
              [src]="notification?.photo"
              class="rounded"
              alt="image"
              width="60"
            />
          </div>

          <div class="product-about">
            <p class="m-0 text-black fw-bold">{{ notification?.title }}</p>
            <p
              class="mb-0 text-black"
              nz-popover
              nzType="primary"
              nzPopoverTitle=""
              [nzPopoverContent]="notification?.text"
              [nzPopoverOverlayStyle]='{width : "300px"}'
            >
              {{ notification?.text }}
            </p>
          </div>

        </div>

      </div>


    </div>




    <div
    class="align-items-center d-flex flex-column justify-content-center notification-dropdown"
    *ngIf="!notificationsData?.length"
    >

      <div class="my-4 product-detail w-100">

        <div class="d-flex justify-content-center">
          <svg height="60px" width="60px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 384 384" xml:space="preserve">
            <path style="fill:#FFC33B;" d="M345.272,310l-28.8-48c-5.6-9.2-9.2-19.2-10.4-29.6l-17.6-120c-5.2-21.2-20.4-38.4-40.4-46.4l-4.8-2
            c-1.6-0.8-3.6-1.2-5.6-2s-3.6-2-4.8-4l-20.8-39.6c-2.8-6.4-9.6-10.4-17.2-10.4h-4c-7.6,0-14,4-17.6,10.8l-20.8,39.2
            c-1.2,2-2.8,3.2-4.8,4c-2.4,0.8-4.8,1.6-6.8,2.4l-4.4,1.6c-20,8-35.2,25.2-40.4,46.4l0,0l-17.6,120c-1.6,10.4-5.2,20.4-10.4,29.6
            l-28.8,48c-4.8,8,0.8,18,10.4,18h285.6C344.072,328,350.072,318,345.272,310L345.272,310z"/>
            <path style="fill:#F1BB40;" d="M242.872,260c-3.2-12.8-5.6-34-5.6-47.2V67.6c22,10,37.2,27.2,42.4,48.4l17.6,108.4
            c1.6,10.4,5.2,20.4,10.4,29.6l28.8,48c4.8,8-0.8,18-10.4,18h-44.8c-13.2,0-26.4-10.4-29.6-23.2L242.872,260L242.872,260z"/>
            <path style="fill:#ABE6ED;" d="M229.272,338c0,20.8-17.2,38-38,38s-38-17.2-38-38v-10h76V338L229.272,338z"/>
            <path style="fill:#56B27D;" d="M191.272,384c-25.2,0-46-20.8-46-46v-18h92v18C237.272,363.2,216.472,384,191.272,384z M161.272,336
            v2c0,16.4,13.6,30,30,30s30-13.6,30-30v-2H161.272z"/>
            <path style="fill:#BB8814;" d="M335.272,336h-285.6c-7.6,0-14-3.6-17.6-10c-3.6-6.4-3.6-13.6,0.4-20l28.8-48
            c4.8-8.4,8-17.6,9.2-26.8l17.6-120.8c5.6-23.6,22.8-42.8,45.2-52l4.8-1.6c2-0.8,4.4-1.6,6.8-2.4c0.4,0,0.4-0.4,0.4-0.4l20.8-38.8
            c4.8-9.6,14.4-15.2,24.8-15.2h4c10.8,0,20.4,6,24.4,14.8l20.4,39.2c0,0,0.4,0.4,0.8,0.4c0.8,0.4,1.2,0.4,2,0.8
            c1.2,0.4,2.4,0.8,4,1.6l4.4,2c22.4,8.8,39.2,28.4,45.2,52v0.8l17.6,120c1.2,9.2,4.4,18,9.2,26.8l28.8,48c3.6,6.4,4,13.6,0.4,20
            C348.872,332,342.472,336,335.272,336z M104.072,114l-17.6,119.6c-1.6,11.2-5.6,22-11.2,32.4l-28.8,48c-1.2,1.6-0.4,3.2,0,4
            s1.6,2,3.6,2h285.6c2,0,2.8-1.6,3.2-2c0.4-0.8,0.8-2.4,0-4l-28.8-48c-6.4-10.4-10-21.6-11.6-32.8l-17.6-119.2
            c-4.8-18.4-18-33.6-35.6-40.4l-5.6-2.4c-0.4-0.4-1.2-0.4-2-0.8c-1.2-0.4-2-0.8-3.2-1.2c-3.6-1.6-6.8-4-8.8-7.2l-0.4-0.4l-21.2-40
            c-1.6-3.6-5.2-5.6-10-5.6h-4c-4.4,0-8.4,2.4-10.4,6.4l-21.2,39.6c-2,3.2-4.8,6-8.8,7.2h-0.4c-2.4,0.8-4.4,1.6-6.4,2.4l-4.8,1.6
            C121.672,80.4,108.472,95.6,104.072,114z"/>
            <g>
            <path style="fill:#C6490F;" d="M246.872,253.2c-2,0-4-0.8-5.6-2.4l-113.2-113.2c-3.2-3.2-3.2-8,0-11.2s8-3.2,11.2,0l113.2,113.2
              c3.2,3.2,3.2,8,0,11.2C250.872,252.4,248.872,253.2,246.872,253.2z"/>
            <path style="fill:#C6490F;" d="M133.672,253.2c-2,0-4-0.8-5.6-2.4c-3.2-3.2-3.2-8,0-11.2l113.2-113.2c3.2-3.2,8-3.2,11.2,0
              s3.2,8,0,11.2l-113.2,113.2C137.672,252.4,135.672,253.2,133.672,253.2z"/>
            </g>
          </svg>
        </div>

      </div>


      <div class="align-items-end d-flex justify-content-center text-center">
        <h3 (click)="close_window();" class="fs-6 fw-light mb-5 p-2 rounded-3 text-dark">
         {{ 'notifications_not_found' | translate: 'header' }}
        </h3>
      </div>

    </div>

  </div>


</div>
